export default __webpack_public_path__ + "static/media/mozilla.6c92f232.svg";